import React, { ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

interface GuideModalProps {
  children: ReactNode;
  onActiveChange: (isOpen: boolean) => void;
}

export const GuideModal = ({ children, onActiveChange }: GuideModalProps) => {
  return (
    <Dialog onOpenChange={onActiveChange}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        className="max-w-[80vw] w-[80vw] h-[90vh] p-4 flex flex-col"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader className="p-0 space-y-0 flex-shrink-0">
          <DialogTitle className="text-lg">User Guide</DialogTitle>
        </DialogHeader>
        <div className="flex-1">
          <iframe
            src="/user-guide.pdf"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="PDF Viewer"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
